import {TorchAPIConfiguration, TorchAPIConfigurationParams} from './config/api.configuration';
import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  TorchCRTModule, TorchDevopsEngineeringModule,
  TorchDocumentationModule,
  TorchEOModule,
  TorchFilesModule, TorchFleetTeamModule,
  TorchMetricsModule,
  TorchMiscModule,
  TorchPainIndexesModule,
  TorchQueryFiltersModule,
  TorchUsersModule,
} from './modules';
import {LoggingService} from '../app/shared/services/logging.service';


@NgModule({
  imports: [
    CommonModule,
    TorchUsersModule,
    TorchCRTModule,
    TorchDocumentationModule,
    TorchEOModule,
    TorchDevopsEngineeringModule,
    TorchFilesModule,
    TorchFleetTeamModule,
    TorchMetricsModule,
    TorchMiscModule,
    TorchPainIndexesModule,
    TorchQueryFiltersModule
  ],
})
export class TorchBackendModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchBackendModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchBackendModule is already loaded. Import in your base AppModule only.');
    }

    logger.log('Loaded TorchBackendModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchBackendModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
